'use client';

import React from 'react';

import { useModal } from '@/contexts/ModalContext';
import GoalList from '@/components/goals/GoalList';
import { GoalModel } from '@/types/goals';

interface GoalListModalProps {
  propsSelectedGoal: GoalModel | undefined;
  onSelectGoal: (goal: GoalModel | undefined) => void;
  onMoveToGoals?: () => void;
}

const GoalListModal: React.FC<GoalListModalProps> = ({ propsSelectedGoal, onSelectGoal, onMoveToGoals }) => {
  /**
   * react context
   */
  const { closeModal } = useModal();

  const handleSelectGoal = (goal: GoalModel | undefined) => {
    onSelectGoal(goal);
    closeModal();
  };

  const handleMoveToGoals = () => {
    if (onMoveToGoals) {
      onMoveToGoals();
      closeModal();
    }
  };

  /**
   * モーダル閉じる
   */
  const handleModalClick = (e: React.MouseEvent<HTMLDivElement>) => {
    // モーダルの背景をクリックした場合にだけ closeModal を呼び出す
    const modalBackground = document.getElementById('modal-background');
    if (e.target === modalBackground) {
      closeModal();
    }
  };

  return (
    <div
      id="modal-background"
      className="fixed inset-0 z-30 w-full flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none"
      onClick={handleModalClick}>
      <div className="relative w-11/12 sm:w-6/12 max-h-[85dvh] overflow-y-auto rounded-lg">
        <div className="relative flex flex-col bg-white border-0 rounded-lg outline-none focus:outline-none">
          <div className="flex justify-between items-center border-b border-green-500 px-4 py-2 bg-white sticky top-0 z-10 rounded-t-lg">
            <h3 className="font-footballlog italic text-lg font-semibold text-gray-500 dark:text-white">
              My Goals<span className="text-sm"> - 目標・課題を選択</span>
            </h3>
            <button
              type="button"
              onClick={closeModal}
              className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white">
              <svg
                className="w-3 h-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14">
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg>
              <span className="sr-only">Close menu</span>
            </button>
          </div>
          <div className="relative p-4">
            <GoalList
              propsSelectedGoal={propsSelectedGoal}
              onSelectGoal={handleSelectGoal}
              onMoveToGoals={handleMoveToGoals}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GoalListModal;
